"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _IconButtonWithTooltip = _interopRequireDefault(require("@sprinx/react-mui-components/IconButtonWithTooltip"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _useCountriesFlag = _interopRequireDefault(require("./useCountriesFlag"));

var _useRegionHrefsOrDefault = _interopRequireDefault(require("./useRegionHrefsOrDefault"));

var supportedRegions = ['AT', 'BG', 'CZ', 'DE', 'DK', 'FR', 'GR', 'HR', 'HU', 'IT', 'PL', 'RO', 'SI', 'SK']; // 'RS',

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }, theme.breakpoints.down('sm'), {
      justifyContent: 'center'
    }),
    icon: {
      '& svg': {
        width: 24,
        height: 24
      }
    },
    languageIcon: {
      padding: theme.spacing(0.5),
      '& svg': {
        width: theme.spacing(3),
        height: theme.spacing(3)
      }
    }
  };
}, {
  name: 'SxAppBarActionRegion'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_Close.default, null);

function AppBarActionRegion(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "onChange"]);
  var classes = useStyles({
    classes: pClasses,
    className: className
  });
  var t = (0, _useTranslate.default)();
  var countriesFlag = (0, _useCountriesFlag.default)();
  var hrefs = (0, _useRegionHrefsOrDefault.default)();

  var handleClose = _react.default.useCallback(function () {
    if (onChange) {
      onChange(false);
    }
  }, [onChange]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), (countriesFlag || []).map(function (i, index) {
    return supportedRegions.includes(i.region) && /*#__PURE__*/_react.default.createElement(_IconButtonWithTooltip.default, (0, _extends2.default)({
      key: index.toString()
    }, rest, {
      className: (0, _clsx.default)(classes.icon, className),
      icon: i.icon,
      label: i.region,
      href: hrefs[i.region]
    }));
  }), /*#__PURE__*/_react.default.createElement(_IconButtonWithTooltip.default, {
    label: t('appBarActionRegion/label'),
    icon: _ref2,
    onClick: handleClose
  }));
}

process.env.NODE_ENV !== "production" ? AppBarActionRegion.propTypes = {
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    languageIcon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onChange: _propTypes.default.func
} : void 0;
AppBarActionRegion.defaultProps = {
  classes: undefined,
  className: undefined,
  onChange: undefined
};
var _default = AppBarActionRegion;
exports.default = _default;